import React, { useEffect, useState } from 'react';
import useAuthRequest from '../../../services/requests.service';
import { DotLoader } from 'react-spinners';
import PlanCard from './PlanCard';
import NewPlanModal from './NewPlanModal';

const PlansSub = ({ page }) => {
  const request = useAuthRequest();
  const [plans, setPlans] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activePlanIndex, setActivePlanIndex] = useState(0);
  const [showNewPlanModal, setShowNewPlanModal] = useState(false);

  useEffect(() => {
    fetchPlans();
  }, [page._id]);

  const fetchPlans = async () => {
    setIsLoading(true);
    try {
      const res = await request.getDataAPI(`companyPlans/${page._id}`);
      setPlans(res.plans || []);
      setActivePlanIndex(0);
    } catch (e) {
      console.error('Failed to fetch plans', e);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-[200px] flex justify-center items-center">
        <DotLoader size={60} color="#6076E7" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      {/* Sous-onglets */}
      <div className="flex items-center gap-2 flex-wrap">
        {plans.map((plan, index) => (
          <button
            key={plan._id}
            onClick={() => setActivePlanIndex(index)}
            className={`px-3 py-1 rounded-full text-sm font-semibold border transition-all ${
              activePlanIndex === index
                ? plan.type === 'permanent'
                  ? 'bg-royalblue-500 text-white border-royalblue-500'
                  : 'bg-amber-500 text-white border-amber-500'
                : plan.type === 'permanent'
                  ? 'bg-white text-royalblue-500 border-royalblue-500'
                  : 'bg-white text-amber-500 border-amber-500'
            }`}
          >
            {plan.type === 'permanent' ? '● Permanent' : '◆ Saisonnier'}
          </button>
        ))}
        <button
          onClick={() => setShowNewPlanModal(true)}
          className="px-3 py-1 rounded-full text-sm text-slate-400 border border-dashed border-slate-300 hover:border-slate-400 transition-all"
        >
          + Nouveau plan
        </button>
      </div>

      {/* Contenu */}
      {plans.length === 0 ? (
        <div className="text-center py-16 text-slate-400">
          <p className="mb-4">Aucun abonnement actif</p>
          <button
            onClick={() => setShowNewPlanModal(true)}
            className="px-4 py-2 bg-royalblue-500 text-white rounded-lg text-sm"
          >
            Créer votre premier abonnement
          </button>
        </div>
      ) : (
        <PlanCard
          plan={plans[activePlanIndex]}
          onSeatsUpdated={fetchPlans}
        />
      )}

      {showNewPlanModal && (
        <NewPlanModal
          page={page}
          hasPermamentPlan={plans.some(p => p.type === 'permanent')}
          onClose={() => setShowNewPlanModal(false)}
        />
      )}
    </div>
  );
};

export default PlansSub;
